import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { DbRecord } from '../db-record'
import { Project } from '../project'
import { RuntimeService } from '../runtime.service'
import { FilterService } from '../filter.service'
import { SortService } from '../sort.service'
import { CriterionService } from '../criterion.service'
import { SearchLogService } from '../search-log.service'
import { DbRecordService } from '../db-record.service'

@Component({
  selector: 'app-db-record-box',
  templateUrl: './db-record-box.component.html',
  styleUrls: ['./db-record-box.component.css']
})
export class DbRecordBoxComponent implements OnInit {
  @Input() dbRecord: DbRecord
  @Input() order: number
  @Input() isInside = false
  project: Project
  private _searchDetailsOn = false
  isCite: boolean

  constructor(
    private elr: ElementRef,
    private rs: RuntimeService,
    private fs: FilterService,
    private ss: SortService,
    private cs: CriterionService,
    private sls: SearchLogService,
    private dbrs: DbRecordService
  ) {
    this.project = this.rs.currentProject
  }

  ngOnInit() {
  }

  get editManualOn() {
    return this.dbrs.isEditedRecord(this.dbRecord)
  }

  switchCite() {
    this.isCite = !this.isCite
  }

  switchEditManual() {
    this.dbrs.switchEditedRecord(this.dbRecord)
  }

  switchSearchDetailsOn() {
    this._searchDetailsOn = !this._searchDetailsOn
  }

  get searchLogDetails() {
    let data = this.sls.resolve(this.searchCode)
    if (!data)
      return "NOT RESOLVED"
    return `
<table>
<tr><th>Database:<th><td>${data['db']}</td></tr>
<tr><th>Date:<th><td>${data['date']}</td></tr>
<tr><th>Hits:<th><td>${data['hits']}</td></tr>
<tr><th>Search:<th><td>${data['searchDetail']}</td></tr>
<tr><th>Hash:<th><td>${data['searchHash']}</td></tr>
</table>
    `
  }

  jumpHome() {
    window.scrollTo(0, 0)
  }

  jumpTop() {
    let el = this.elr.nativeElement
    window.scrollTo(el.offsetLeft, el.offsetTop)
  }

  jumpNext() {
    let nextSibling = this.elr.nativeElement.nextSibling
    window.scrollTo(nextSibling.offsetLeft, nextSibling.offsetTop)
  }

  jumpPrev() {
    let prevSibling = this.elr.nativeElement.previousSibling
    window.scrollTo(prevSibling.offsetLeft, prevSibling.offsetTop)
  }

  get searchDetailsOn() {
    return this._searchDetailsOn
  }

  get searchCode() {
    return this.dbRecord.searchCode
  }

  get title() {
    return this.ss.highlightSortHits(this.dbRecord,
      this.fs.highlightSearchHits(this.dbRecord.title))
  }

  get abstract() {
    return this.ss.highlightSortHits(this.dbRecord,
      this.fs.highlightSearchHits(this.dbRecord.abstract))
  }

  get citation() {
    return this.dbRecord.shortCitation
  }

  get weight() {
    return Math.round(-1 * this.cs.currentCriterion.valuesMap.get(this.dbRecord.id))
  }

}



// WEBPACK FOOTER //
// ./src/app/db-record-box/db-record-box.component.ts